import React from 'react';
import shortUUID from 'short-uuid';
import './styles.css';
import { Tooltip } from '../Tooltip';
import { ValidateError } from '../ErrorMessage';

export const Radio = ({
  id,
  label,
  initialLabelStrong = '',
  color,
  className,
  value,
  onChange,
  field,
  form,
  tooltip,
  ...props
}) => {
  const uuid = shortUUID.generate();

  return field ? (
    <label
      className={`radio_container ${color || ''} ${className}`}
      htmlFor={id || uuid}
    >
      <p>
        <strong>{initialLabelStrong}</strong>
        {label || ''}
        {tooltip && <Tooltip title={tooltip}>?</Tooltip>}
        <input
          {...props}
          {...field}
          type="radio"
          id={id || uuid}
          value={value}
          checked={form.values[field.name] === value}
          onChange={(e) => {
            form.setFieldValue(field.name, value);
            if (onChange) {
              onChange(e);
            }
          }}
          onBlur={() => form.setFieldTouched(field.name)}
        />
        <span className="radio_dot" />
        {form.touched[field.name] && form.errors[field.name] && (
          <ValidateError>{form.errors[field.name]}</ValidateError>
        )}
      </p>
    </label>
  ) : (
    <label className={`radio_container ${color || ''}`} htmlFor={id || uuid}>
      {label || ''}
      {tooltip && <Tooltip title={tooltip}>?</Tooltip>}
      <input type="radio" id={id || uuid} {...props} value={value} />
      <span className="radio_dot" />
    </label>
  );
};
